import {Box} from "@mui/material";

function CourseDescriptionColumn({
    left = false,
    children
}) {
    const style = {
        width: "100%"
    }
    if (left) {
        style.marginLeft = { md: "9vw", xs: "0px" };
    } else {
        style.marginRight = "9vw";
    }

    return (
        <Box sx={style}>
            { children }
        </Box>
    )
}

export default CourseDescriptionColumn;